import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ConfirmationModal = ({
  title,
  subTitle,
  yesBtnText,
  noBtnText,
  yesBtnAction,
  noBtnAction,
  show,
  setShow
}) => {
  const handleClose = () => setShow(false);
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      contentClassName="rounded-5 wr-fe-another-donation-modal"
    >
      <Modal.Body>
        <div className="text-center">
          <p
            className="font-patrick text-primary mb-2 lh-1"
            style={{ fontSize: '42px' }}
          >
            {title}
          </p>
          <p className="fs-0">{subTitle}</p>
        </div>
        <div className="mt-3">
          <Button
            variant="primary"
            size="lg"
            className="mb-3 w-100 text-uppercase py-2 fs-0"
            onClick={() => {
              handleClose();
              yesBtnAction();
            }}
          >
            {yesBtnText}
          </Button>
          <Button
            variant="falcon-default"
            size="lg"
            className="w-100 py-2 fs--1 bg-200 border-200 hover-bg-primary hover-border-primary hover-100"
            onClick={() => {
              handleClose();
              noBtnAction();
            }}
          >
            {noBtnText}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  yesBtnText: PropTypes.node.isRequired,
  noBtnText: PropTypes.node.isRequired,
  yesBtnAction: PropTypes.func.isRequired,
  noBtnAction: PropTypes.func.isRequired
};

export default ConfirmationModal;
